export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M21.5793 14.7248H8.42139V12.2577H21.5793V14.7248Z" fill="black" />
            <path fillRule="evenodd" clipRule="evenodd" d="M21.5793 21.3037H8.42139V18.8366H21.5793V21.3037Z" fill="black" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8885 2.80045V4.44519H19.1122V2.80045H10.8885ZM10.0661 0.333344C9.15776 0.333344 8.42139 1.06972 8.42139 1.97808V5.26755C8.42139 6.17592 9.15776 6.91229 10.0661 6.91229H19.9345C20.8429 6.91229 21.5793 6.17592 21.5793 5.26755V1.97808C21.5793 1.06972 20.8429 0.333344 19.9345 0.333344H10.0661Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0662 1.97809H2.66486C1.30231 1.97809 0.197754 3.08265 0.197754 4.44519V29.1162C0.197754 30.4788 1.30231 31.5834 2.66486 31.5834H27.3359C28.6985 31.5834 29.803 30.4788 29.803 29.1162V4.44519C29.803 3.08265 28.6985 1.97809 27.3359 1.97809H19.9346V4.44519H27.3359V29.1162H2.66486L2.66486 4.44519H10.0662V1.97809Z"
                fill="black"
            />
        </svg>
    );
}
